module.exports = __webpack_public_path__ + "img/seher_px3.eacf43ac.png";